import React from "react";
import { Table } from "react-bootstrap";
import DeviceRow from "containers/Devices/Ota/DeviceRowOta";

const DeviceTableOta = ({ list, hideVendors, show }) => {
  if (!show) return null;

  return (
    <Table striped condensed hover className="ctia-table">
      <thead>
        <tr>
          {hideVendors ? null : <th>Vendor</th>}
          <th>Model Name/Number</th>
          <th>Approval Date</th>
        </tr>
      </thead>
      <tbody>
        <DeviceRow tableData={list} hideVendors={hideVendors} />
      </tbody>
    </Table>
  );
};

export default DeviceTableOta;
